import type { OpenAPI } from "../../interfaces";
import SearchParams from "../searchParams";

export const innointel = (api) => ({
  getSearches(
    params: OpenAPI.GET<"/innointel/searches">["parameters"]["query"],
    success: (data: OpenAPI.GET<"/innointel/searches">["response"]) => void,
    fail,
  ) {
    const queryParams = new SearchParams(params);
    api.authenticatedRequest(
      "GET",
      `/innointel/searches${queryParams.toSafeString()}  `,
      null,
      success,
      fail,
    );
  },
  getSearch(
    searchId: string,
    success: (
      data: OpenAPI.GET<"/innointel/searches/{search_id}">["response"],
    ) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "GET",
      `/innointel/searches/${searchId}`,
      null,
      success,
      fail,
    );
  },
  getSearchCompanies(
    searchId: string,
    params: OpenAPI.GET<"/innointel/searches/{search_id}/companies">["parameters"]["query"],
    success: (
      data: OpenAPI.GET<"/innointel/searches/{search_id}/companies">["response"],
    ) => void,
    fail,
  ) {
    const queryParams = new SearchParams(params);
    api.authenticatedRequest(
      "GET",
      `/innointel/searches/${searchId}/companies${queryParams.toSafeString()}`,
      null,
      success,
      fail,
    );
  },
  addCompanyToSearch(
    searchId: string,
    data: OpenAPI.POST<"/innointel/searches/{search_id}/companies">["requestBody"],
    success: (
      data: OpenAPI.POST<"/innointel/searches/{search_id}/companies">["response"],
    ) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "POST",
      `/innointel/searches/${searchId}/companies`,
      data,
      success,
      fail,
    );
  },
  excludeCompanies(
    searchId: string,
    data: OpenAPI.POST<"/innointel/searches/{search_id}/companies/exclude">["requestBody"],
    success: (
      data: OpenAPI.POST<"/innointel/searches/{search_id}/companies/exclude">["response"],
    ) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "POST",
      `/innointel/searches/${searchId}/companies/exclude`,
      data,
      success,
      fail,
    );
  },
  includeCompanies(
    searchId: string,
    data: OpenAPI.POST<"/innointel/searches/{search_id}/companies/include">["requestBody"],
    success: (
      data: OpenAPI.POST<"/innointel/searches/{search_id}/companies/include">["response"],
    ) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "POST",
      `/innointel/searches/${searchId}/companies/include`,
      data,
      success,
      fail,
    );
  },
  newSearch(
    data: OpenAPI.POST<"/innointel/searches/new">["requestBody"],
    success: (
      data: OpenAPI.POST<"/innointel/searches/new">["response"],
    ) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "POST",
      `/innointel/searches/new`,
      data,
      success,
      fail,
    );
  },
  cancelSearch(
    searchId: string,
    success: (
      data: OpenAPI.POST<"/innointel/searches/{search_id}/cancel">["response"],
    ) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "POST",
      `/innointel/searches/${searchId}/cancel`,
      null,
      success,
      fail,
    );
  },
  restartSearch(
    searchId: string,
    success: (
      data: OpenAPI.POST<"/innointel/searches/{search_id}/restart">["response"],
    ) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "POST",
      `/innointel/searches/${searchId}/restart`,
      null,
      success,
      fail,
    );
  },
  processCompanies(
    searchId: string,
    data: OpenAPI.POST<"/innointel/searches/{search_id}/companies/process">["requestBody"],
    success: (
      data: OpenAPI.POST<"/innointel/searches/{search_id}/companies/process">["response"],
    ) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "POST",
      `/innointel/searches/${searchId}/companies/process`,
      data,
      success,
      fail,
    );
  },
  deleteSearch(
    searchId: string,
    success: (
      data: OpenAPI.DELETE<"/innointel/searches/{search_id}">["response"],
    ) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "DELETE",
      `/innointel/searches/${searchId}`,
      null,
      success,
      fail,
    );
  },
  getCompany(
    companyId: string,
    success: (
      data: OpenAPI.GET<"/innointel/companies/{company_id}">["response"],
    ) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "GET",
      `/innointel/companies/${companyId}`,
      null,
      success,
      fail,
    );
  },
  triggerCompanyEvent(
    companyId: string,
    data: OpenAPI.POST<"/innointel/companies/{company_id}/events">["requestBody"],
    success: (
      data: OpenAPI.POST<"/innointel/companies/{company_id}/events">["response"],
    ) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "POST",
      `/innointel/companies/${companyId}/events`,
      data,
      success,
      fail,
    );
  },
  assignCreditsafeId(
    companyId: string,
    body: OpenAPI.POST<"/innointel/companies/{company_id}/creditsafe/assign">["requestBody"],
    success: (
      data: OpenAPI.GET<"/innointel/companies/{company_id}/creditsafe/assign">["response"],
    ) => void,
    fail: (error: any) => void,
  ) {
    api.authenticatedRequest(
      "POST",
      `/innointel/companies/${companyId}/creditsafe/assign`,
      body,
      success,
      fail,
    );
  },
  getCreditsafeReport(
    companyId: string,
    creditsafeIdToUse: string | undefined,
    success: (
      data: OpenAPI.GET<"/innointel/companies/{company_id}/creditsafe/report">["response"],
    ) => void,
    fail: (error: any) => void,
  ) {
    api.authenticatedRequest(
      "GET",
      `/innointel/companies/${companyId}/creditsafe/report${creditsafeIdToUse ? `?creditsafeId=${creditsafeIdToUse}` : ""}`,
      null,
      success,
      fail,
    );
  },
  getCreditsafeReportPdf(
    companyId: string,
    success: (
      data: OpenAPI.GET<"/innointel/companies/{company_id}/creditsafe/pdf">["response"],
    ) => void,
    fail: (error: any) => void,
  ) {
    api.authenticatedRequest(
      "GET",
      `/innointel/companies/${companyId}/creditsafe/pdf`,
      null,
      success,
      fail,
    );
  },
  getLists(
    success: (data: OpenAPI.GET<"/innointel/lists">["response"]) => void,
    fail,
  ) {
    api.authenticatedRequest("GET", "/innointel/lists", null, success, fail);
  },
  createList(
    data: OpenAPI.PUT<"/innointel/lists">["requestBody"],
    success: (data: OpenAPI.PUT<"/innointel/lists">["response"]) => void,
    fail,
  ) {
    api.authenticatedRequest("PUT", "/innointel/lists", data, success, fail);
  },
  getList(
    listId: string,
    success: (
      data: OpenAPI.GET<"/innointel/lists/{list_id}">["response"],
    ) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "GET",
      `/innointel/lists/${listId}`,
      null,
      success,
      fail,
    );
  },
  updateList(
    listId: string,
    data: OpenAPI.POST<"/innointel/lists/{list_id}">["requestBody"],
    success: (
      data: OpenAPI.POST<"/innointel/lists/{list_id}">["response"],
    ) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "POST",
      `/innointel/lists/${listId}`,
      data,
      success,
      fail,
    );
  },
  deleteList(
    listId: string,
    success: (
      data: OpenAPI.DELETE<"/innointel/lists/{list_id}">["response"],
    ) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "DELETE",
      `/innointel/lists/${listId}`,
      null,
      success,
      fail,
    );
  },
  duplicateList(
    listId: string,
    data: OpenAPI.POST<"/innointel/lists/{list_id}/duplicate">["requestBody"],
    success: (
      data: OpenAPI.POST<"/innointel/lists/{list_id}/duplicate">["response"],
    ) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "POST",
      `/innointel/lists/${listId}/duplicate`,
      data,
      success,
      fail,
    );
  },
  shareList(
    listId: string,
    data,
    success: (
      data: OpenAPI.POST<"/innointel/lists/{list_id}/share">["response"],
    ) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "POST",
      `/innointel/lists/${listId}/share`,
      data,
      success,
      fail,
    );
  },
  unshareList(
    listId: string,
    data,
    success: (
      data: OpenAPI.DELETE<"/innointel/lists/{list_id}/share">["response"],
    ) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "DELETE",
      `/innointel/lists/${listId}/share`,
      data,
      success,
      fail,
    );
  },
  connectExcel(
    listId: string,
    success: (
      data: OpenAPI.POST<"/innointel/lists/{list_id}/connections/microsoftExcel">["response"],
    ) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "POST",
      `/innointel/lists/${listId}/connections/microsoftExcel`,
      null,
      success,
      fail,
    );
  },
  createPowerbiDataset(
    listId: string,
    data: OpenAPI.POST<"/innointel/lists/{list_id}/connections/powerbi">["requestBody"],
    success: (
      data: OpenAPI.POST<"/innointel/lists/{list_id}/connections/powerbi">["response"],
    ) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "POST",
      `/innointel/lists/${listId}/connections/powerbi`,
      data,
      success,
      fail,
    );
  },
  deletePowerbiDataset(
    listId: string,
    datasetId: string,
    success: (
      data: OpenAPI.DELETE<"/innointel/lists/{list_id}/connections/powerbi/{dataset_id}">["response"],
    ) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "DELETE",
      `/innointel/lists/${listId}/connections/powerbi/${datasetId}`,
      null,
      success,
      fail,
    );
  },
  getListCompanies(
    listId: string,
    params: OpenAPI.GET<"/innointel/lists/{list_id}/companies">["parameters"]["query"],
    success: (
      data: OpenAPI.GET<"/innointel/lists/{list_id}/companies">["response"],
    ) => void,
    fail,
  ) {
    const urlParams = new SearchParams(params);
    api.authenticatedRequest(
      "GET",
      `/innointel/lists/${listId}/companies${urlParams.toSafeString()}`,
      null,
      success,
      fail,
    );
  },
  addListCompanies(
    listId: string,
    data,
    success: (
      data: OpenAPI.POST<"/innointel/lists/{list_id}/companies">["response"],
    ) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "POST",
      `/innointel/lists/${listId}/companies`,
      data,
      success,
      fail,
    );
  },
  removeListCompanies(
    listId: string,
    data,
    success: (
      data: OpenAPI.DELETE<"/innointel/lists/{list_id}/companies">["response"],
    ) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "DELETE",
      `/innointel/lists/${listId}/companies`,
      data,
      success,
      fail,
    );
  },
  emailCompanies(listId: string, data, success, fail) {
    const params: { listId?: string } = {};
    if (listId) {
      params.listId = listId;
    }
    const urlParams = new SearchParams(params);
    api.authenticatedRequest(
      "POST",
      `/innointel/companies/email?${urlParams.toString()}`,
      data,
      success,
      fail,
    );
  },
  subscribeToList(
    listId: string,
    success: (
      data: OpenAPI.POST<"/innointel/lists/{list_id}/subscribe">["response"],
    ) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "POST",
      `/innointel/lists/${listId}/subscribe`,
      null,
      success,
      fail,
    );
  },
  unsubscribeFromList(
    listId: string,
    success: (
      data: OpenAPI.DELETE<"/innointel/lists/{list_id}/subscribe">["response"],
    ) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "DELETE",
      `/innointel/lists/${listId}/subscribe`,
      null,
      success,
      fail,
    );
  },
  getListNews(
    listId: string,
    page: number,
    success: (
      data: OpenAPI.GET<"/innointel/lists/{list_id}/news">["response"],
    ) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "GET",
      `/innointel/lists/${listId}/news?page=${page}`,
      null,
      success,
      fail,
    );
  },
  getListLogs(
    listId: string,
    success: (
      data: OpenAPI.GET<"/innointel/lists/{list_id}/logs">["response"],
    ) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "GET",
      `/innointel/lists/${listId}/logs`,
      null,
      success,
      fail,
    );
  },
  getListAnalysis(
    listId: string,
    success: (
      data: OpenAPI.GET<"/innointel/lists/{list_id}/analysis">["response"],
    ) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "GET",
      `/innointel/lists/${listId}/analysis`,
      null,
      success,
      fail,
    );
  },
  getDashboards(
    params: OpenAPI.GET<"/innointel/dashboards">["parameters"]["query"],
    success: (data: OpenAPI.GET<"/innointel/dashboards">["response"]) => void,
    fail,
  ) {
    const queryParams = new SearchParams(params);
    api.authenticatedRequest(
      "GET",
      `/innointel/dashboards${queryParams.toSafeString()}`,
      null,
      success,
      fail,
    );
  },
  createDashboard(
    data: OpenAPI.PUT<"/innointel/dashboards">["requestBody"],
    success: (data: OpenAPI.PUT<"/innointel/dashboards">["response"]) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "PUT",
      "/innointel/dashboards",
      data,
      success,
      fail,
    );
  },
  getDashboard(
    id: string,
    success: (
      data: OpenAPI.GET<"/innointel/dashboards/{dashboard_id}">["response"],
    ) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "GET",
      `/innointel/dashboards/${id}`,
      null,
      success,
      fail,
    );
  },
  refreshDashboard(id, success, fail) {
    api.authenticatedRequest(
      "POST",
      `/innointel/dashboards/${id}`,
      null,
      success,
      fail,
    );
  },
  deleteDashboard(id, success, fail) {
    api.authenticatedRequest(
      "DELETE",
      `/innointel/dashboards/${id}`,
      null,
      success,
      fail,
    );
  },
  subscribeToDashboard(id, toSubscribe, success, fail) {
    api.authenticatedRequest(
      toSubscribe ? "POST" : "DELETE",
      `/innointel/dashboards/${id}/subscribe`,
      null,
      success,
      fail,
    );
  },
  updateDashboardEventLocation(id, data, success, fail) {
    api.authenticatedRequest(
      "POST",
      `/innointel/dashboards/${id}/eventLocation`,
      data,
      success,
      fail,
    );
  },
  getNotes(id, success, fail) {
    api.authenticatedRequest(
      "GET",
      `/innointel/companies/${id}/notes`,
      null,
      success,
      fail,
    );
  },
  createNote(id, data, success, fail) {
    api.authenticatedRequest(
      "PUT",
      `/innointel/companies/${id}/notes`,
      data,
      success,
      fail,
    );
  },
  editNote(id, noteId, data, success, fail) {
    api.authenticatedRequest(
      "POST",
      `/innointel/companies/${id}/notes/${noteId}`,
      data,
      success,
      fail,
    );
  },
  deleteNote(id, noteId, success, fail) {
    api.authenticatedRequest(
      "DELETE",
      `/innointel/companies/${id}/notes/${noteId}`,
      null,
      success,
      fail,
    );
  },
});
